const Listar = () => import('../views/Listar')
const routes = [
    {
        name: 'listarNfeEmissor',
        path: '/emissor/notas_fiscais',
        alias: ['/emissor/notas_fiscais/index'],
        component: Listar,
    },
]

export default routes
